export const NewFolderModal: string = 'NewFolderModal';
